/*eslint camelcase: ["error", {properties: "never"}]*/
const anaConsts = require('analytics/constants');

module.exports = {
    pinterestAddToCartEvent: function (data) {
        Sephora.analytics.promises.PinterestBasePixelInitialized.then(() => {
            let pinterestAddToCartEvent = new CustomEvent('pinterestAddToCartEvent', {
                detail: data
            });
            window.dispatchEvent(pinterestAddToCartEvent);
        });
    },

    snapChatAddToCartEvent: function (amount, quantity, currency, items) {
        Sephora.analytics.promises.snapChatReady.then(() => {
            snaptr('track', 'ADD_CART', {
                price: amount,
                number_items: quantity,
                currency: currency,
                item_ids: items.join(',')
            });
        });
    },

    googleAnalyticsAddToBasketEvent: function (data) {
        window.dispatchEvent(new CustomEvent(anaConsts.EVENT_NAMES.ADD_TO_BASKET, {
            detail: data
        }));
    },

    facebookAddToBasketEvent: function (data) {
        window.dispatchEvent(new CustomEvent(anaConsts.EVENT_NAMES.FACEBOOK_ADD_TO_BASKET, {
            detail: data
        }));
    },

    googleAnalyticsRemoveFromBasketEvent: function (data) {
        window.dispatchEvent(new CustomEvent(anaConsts.EVENT_NAMES.REMOVE_FROM_BASKET, {
            detail: data
        }));
    },

    googleAnalyticsBeginCheckout: function () {
        window.dispatchEvent(new CustomEvent(anaConsts.EVENT_NAMES.GA_BEGIN_CHECKOUT));
    }
};
